import xhr from 'xhr'
import validator from './type_validator'
import api from './api'
import setOrigin from './setOrigin'

const autocomplete = () => {
  const address = document.querySelector('#address'),
    zip = document.querySelector('#zipcode'),
    city = document.querySelector('#city'),
    concession = document.querySelector('#dealer'),
    concessionContainer = document.querySelector(
      '.form__input-container--dealer'
    ),
    labelConcession = document.querySelector('.form__label--concession'),
    listConcession = document.querySelector('.autocomplete--concession'),
    listNewZip = document.querySelector('.autocomplete--zipcode'),
    newZipContainer = document.querySelector('.form__input-container--newZip')

  let isValid, newAddress

  return {
    launchAutocomplete: () => {
		// Initialize autocomplete on address input
		let $form = $('.form')
		let dqeParams = {
			server: api().dqe,
			license: '',
			single: '.form__input--address',
			zip: '.form__input--zipcode',
			city: '.form__input--city',
			street: '.form__input--address',
			city_search: 1
		}
		if ($form.hasClass('dqe-findbydealername')) {
			dqeParams.server = api().dqeWithDealers;
			dqeParams.findByDealerName = true;
		}
		window.dqeObject = $form.dqe(dqeParams)

		if (address) {
			address.setAttribute('autocomplete', 'nope')
		}

		// Address selection event
		window.dqeObject.on('single', (e, item) => {
			let dealerID = null;
			if (typeof item !== 'undefined') {
				if (item.dealer_id) {
					dealerID = item.dealer_id
				}
			}

			address.blur()
			address.parentElement.classList.remove('error')
			newAddress = [zip, city]

			address.setAttribute('street', `${address.value}`)
			if (zip != null && !dealerID) {
				address.value += ` ${zip.value} ${city.value} `
			}

			if (concession) {
				concession.value = zip.value
			}

			if (zip != null) {
				isValid = validator().validateAddress(newAddress)
			}

			if (isValid) {
				if (concession != null) {
					let mainElement = document.querySelector('main'),
						contextName = null
					if (mainElement && mainElement.dataset.dealerContext) {
						contextName = mainElement.dataset.dealerContext
					}
					autocomplete().getDealer(contextName, dealerID)
				}

				if (concession) {
					concession.setAttribute('disabled', false)
					concession.parentElement.classList.toggle('opened')
					listConcession.classList.toggle('displayed')
				}
			}
		})

		if (zip) {
			zip.addEventListener('change', e => {
				if (concession) {
					concession.value = zip.value
				}
			})
			zip.parentElement.addEventListener('click', e => {
				e.preventDefault()
				address.focus()
			})
		}

		if (city) {
			city.parentElement.addEventListener('click', e => {
				e.preventDefault()
				address.focus()
			})
		}

		if (concession) {
			concession.disabled = true
			concession.parentElement.addEventListener('click', e => {
				e.preventDefault()
				if (isValid) {
					autocomplete().getDealer()
					concession.parentElement.classList.toggle('opened')
					listConcession.classList.toggle('displayed')
				}
			})
			autocomplete().getNewZipcode()
		}
	},

	  getDealer: (context = null, dealerID = null) => {
		  let
			  encodedAddress = encodeURI(
				  `${address.value} ${zip.value} ${city.value}`,
			  ),
			  questionMarkAdded = false

		  if (typeof context !== 'undefined' && context != null) {
			  encodedAddress += '?cd=' + encodeURI(context)
		  }
		  if (typeof dealerID !== 'undefined' && dealerID != null) {
			  encodedAddress += (questionMarkAdded ? '&' : '?') + 'dealerID=' + encodeURI(dealerID)
		  }
		  if (listConcession) {
			  if (typeof dealerID !== 'undefined' && dealerID != null) {
				  concession.value = `${dealerID}`
				  concession.setAttribute('data-dealer', dealerID)
			  } else {
				  concession.value = `${zip.value}`
			  }
			  concession.parentElement.classList.add('not-null')

			  listConcession.classList.remove('displayed')
			  listConcession.innerHTML = ''

			  // Fetch dealers
			  xhr(
				  {
					  method: 'GET',
					  uri: `${api().bmw}/api/dealer/${encodedAddress}`,
				  },
				  (err, resp, body) => {
					  let data = JSON.parse(body)
					  if (data.length > 0) {
						  labelConcession.classList.add('displayed')
					  } else {
						  labelConcession.classList.remove('displayed')
					  }
					  data.forEach(dealer => {
						  let range = parseFloat(dealer.distance).toFixed(1)
						  const listElem = document.createElement('li')
						  listElem.innerHTML = `<div class="item--address"><div class="item--name">${dealer.name}</div><div class="item--place">${dealer.name}</div><div class="item--city">${dealer.zipcode} - ${dealer.city}</div></div><div class="item--range">${range}km</div>`
						  listElem.classList.add('autocomplete__item')
						  listElem.classList.add(`item--${dealer.id}`)
						  if (data.length === 1) {
							  listElem.classList.add('checked')
						  }
						  listConcession.appendChild(listElem)
						  listConcession
							  .querySelector(`.item--${dealer.id}`)
							  .addEventListener('click', () => {
								  listConcession.classList.remove('displayed')
								  concession.value = `${dealer.code}`
								  concession.setAttribute('data-dealer', dealer.id)
								  validator().checkType(concession)
								  document.querySelectorAll('.autocomplete--concession li').forEach(elem => {
									  elem.classList.remove('checked')
								  })
								  listConcession.querySelector(`.item--${dealer.id}`).classList.add('checked')
								  listConcession.classList.add('has-checked-item')
							  })
					  })
					  if(dealerID) {
						  if(document.querySelector('.autocomplete--concession .autocomplete__item--btn')) {
						  	document.querySelector('.autocomplete--concession .autocomplete__item--btn').classList.add('hidden')
						  }
					  }
					  autocomplete().setNewZipcode()
				  }
			  )
			  listConcession.classList.remove('displayed')
		  }
	  },

    setNewZipcode: () => {
      let newZipLabel = 'Renseignez le code postal de votre autre concessionnaire';
      if ('newZipLabel' in listConcession.dataset) {
        newZipLabel = listConcession.dataset.newZipLabel;
      }
      const triggerNewZip = document.createElement('li')
      triggerNewZip.innerHTML = `<div class="item--blue">`+newZipLabel+`</div>`
      triggerNewZip.classList.add('autocomplete__item')
      triggerNewZip.classList.add('autocomplete__item--btn')
      listConcession.appendChild(triggerNewZip)
      triggerNewZip.addEventListener('click', e => {
        e.preventDefault()
        newZipContainer.parentElement.classList.remove(
          'form__input-container--optional'
        )
        concessionContainer.parentElement.classList.add('hidden')
        listConcession.classList.remove('displayed')
      })
    },

    getNewZipcode: () => {
      if(newZipContainer){
        let newZipcode = newZipContainer.querySelector('input')
        newZipContainer
            .querySelector('.btn--blue')
            .addEventListener('click', e => {
              e.preventDefault()
              autocomplete().launchNewZipcode(e)
            })
        newZipcode.addEventListener('keydown', e => {
          if (e.keyCode === 13) {
            e.preventDefault()
            autocomplete().launchNewZipcode(e)
          }
        })
      }
    },

    launchNewZipcode: e => {
        let zipcodeValue = e.target.value
        if($(e.target).hasClass('btn--blue'))
        {
            zipcodeValue = $(e.target).prev('input').val()
        }
      listNewZip.innerHTML = ''

      let mainElement = document.querySelector('main'),
          contextName = null
      if (mainElement && mainElement.dataset.dealerContext) {
        contextName = mainElement.dataset.dealerContext
      }

      let encodedParams = ''
      if (typeof contextName !== 'undefined' && contextName != null) {
        encodedParams += '?cd=' + encodeURI(contextName)
      }

      if (zipcodeValue && zipcodeValue.length >= 5) {
        // alert('launch new zipcode')
        xhr(
            {
              method: 'GET',
              uri: `${api().bmw}/api/dealer/${zipcodeValue} france${encodedParams}`
            },
          (err, resp, body) => {
            let data = JSON.parse(body)
            data.forEach(dealer => {
              let range = parseFloat(dealer.distance).toFixed(1)
              const listElem = document.createElement('li')
              listElem.innerHTML = `<div class="item--address"><div class="item--name">${dealer.name}</div><div class="item--place">${dealer.name}</div><div class="item--city">${dealer.zipcode} - ${dealer.city}</div></div><div class="item--range">${range}km</div>`
              listNewZip.classList.remove('has-checked-item')
              listElem.classList.add('autocomplete__item')
              listElem.classList.add(`item--${dealer.id}`)
              listNewZip.appendChild(listElem)
              listNewZip
                .querySelector(`.item--${dealer.id}`)
                .addEventListener('click', () => {
                  listNewZip.classList.remove('displayed')
                  concession.value = `${dealer.code}`
                  concession.setAttribute('data-dealer', dealer.id)
                  validator().checkType(concession)
                  document.querySelectorAll('.autocomplete--zipcode li').forEach(elem => {
                    elem.classList.remove('checked')
                  })
                  listNewZip.querySelector(`.item--${dealer.id}`).classList.add('checked')
                  listNewZip.classList.add('has-checked-item')
                })
              listNewZip.classList.add('displayed')
            })
          }
        )
      }
    }
  }
}
export default autocomplete
